var CheckoutStepErrorType = /* @__PURE__ */ ((CheckoutStepErrorType2) => {
  CheckoutStepErrorType2["Failed"] = "failed";
  CheckoutStepErrorType2["Refused"] = "refused";
  CheckoutStepErrorType2["Cancelled"] = "cancelled";
  CheckoutStepErrorType2["Error"] = "error";
  CheckoutStepErrorType2["InternalError"] = "internal-error";
  CheckoutStepErrorType2["ShippingStepFailed"] = "shipping-step-failed";
  CheckoutStepErrorType2["ProductPriceUpdated"] = "product-price-updated";
  return CheckoutStepErrorType2;
})(CheckoutStepErrorType || {});
export {
  CheckoutStepErrorType
};
//# sourceMappingURL=checkout-step-error-type.js.map
